import { render, staticRenderFns } from "./submitState.vue?vue&type=template&id=0760ff5c&scoped=true&"
import script from "./submitState.vue?vue&type=script&lang=js&"
export * from "./submitState.vue?vue&type=script&lang=js&"
import style0 from "./submitState.vue?vue&type=style&index=0&id=0760ff5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0760ff5c",
  null
  
)

export default component.exports